/* ============================================================
   Cart upsell — Recommended products
   Adds curated products to the cart from the cart page and the
   "added to cart" banner. Vanilla JS, no jQuery, no dependencies.

   Integration notes (Empire theme):
   - Cart URLs come from window.Theme.routes (defined in theme.liquid).
   - The header cart count listens for a window 'cartcount:update' event
     whose detail is a cart object (we dispatch it after adding).
   - The banner totals use Shopify.formatMoney (shopify_common.js).
   - Click handling is delegated on document so it also works for the
     banner, which the theme clones into the DOM on each add-to-cart.
   ============================================================ */
(function () {
  'use strict';

  function routes() {
    return (window.Theme && window.Theme.routes) || {};
  }

  // POST a single variant to the cart. Resolves with the add.js response.
  function addToCart(variantId) {
    var url = (routes().cart_add_url || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) {
        // Surface Shopify's error description (e.g. sold out) where possible.
        return res.json().then(
          function (err) {
            throw new Error((err && (err.description || err.message)) || 'Could not add to cart');
          },
          function () {
            throw new Error('Could not add to cart');
          }
        );
      }
      return res.json();
    });
  }

  // Fetch the full cart so we can update the count + banner totals.
  function getCart() {
    var url = (routes().cart_url || '/cart') + '.js';
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  // Update the header count bubble and, if the banner is on screen, its totals.
  function refreshChrome(container) {
    return getCart().then(function (cart) {
      // Reuse the theme's own event so the header count updates for free.
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));

      var subtotalEl = document.querySelector('[data-atc-banner-cart-subtotal]');
      var countEl = document.querySelector('[data-atc-banner-cart-button] span');
      var fmt = container ? container.getAttribute('data-money-format') : null;

      if (subtotalEl && fmt && window.Shopify && typeof Shopify.formatMoney === 'function') {
        subtotalEl.innerHTML = Shopify.formatMoney(cart.total_price, fmt);
      }
      if (countEl) {
        countEl.innerHTML = cart.item_count;
      }
      return cart;
    });
  }

  function handleClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-upsell-add]') : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.hasAttribute('disabled')) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var container = btn.closest('[data-cart-upsell]');
    var context = container ? container.getAttribute('data-context') : 'cart';
    var label = btn.querySelector('.cart-upsell__add-label') || btn;
    var originalText = label.textContent;

    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('is-loading');
    label.textContent = 'Adding…';

    addToCart(variantId)
      .then(function () {
        if (context === 'cart') {
          // On the cart page, reload so the line items, totals and discounts
          // re-render through the theme's own cart markup and JS bindings.
          window.location.reload();
          return null;
        }
        // Banner (or any non-cart-page surface): update in place, no reload.
        return refreshChrome(container).then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          label.textContent = 'Added';
          var item = btn.closest('.cart-upsell__item');
          if (item) item.classList.add('is-added');
        });
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
        label.textContent = originalText || 'Add';
        if (window.console) {
          console.warn('[cart upsell] ' + (err && err.message ? err.message : 'add failed'));
        }
      });
  }

  document.addEventListener('click', handleClick);
})();